import React, { Component } from 'react'
import './ChartWidget.css'
import Chart5 from '../Components/Charts/Chart5'
import IntervalBox from '../Components/Charts/IntervalBox';
import ToggleButton from '../Components/Button/ToggleButton';
import CandleImg from '../img/icon/candlestick.png'
import LineImg from '../img/icon/line.png'
import BarImg from '../img/icon/bar.png'
import SMAConfig from '../Components/Charts/TA/SMAConfig';
import BBConfig from '../Components/Charts/TA/BBConfig';
import RSIConfig from '../Components/Charts/TA/RSIConfig';
import MACDConfig from '../Components/Charts/TA/MACDConfig';
import SKDConfig from '../Components/Charts/TA/SKDConfig';
import FKDConfig from '../Components/Charts/TA/FKDConfig';
import i18next from 'i18next';
import { fxList } from '../lib/constants';
import IconButton from '../Components/Button/IconButton';
import closeIcon from '../img/icon/close.svg';
import Navbar from '../Components/Navbar';
import { cc2ccy } from '../lib/utils';
import CompareToggleButton from '../Components/Button/CompareToggle';

export default class ChartWidget extends Component<any, any> {

    chartRef: any;
    filter: any;
    containerRef: any;
    typeMenuRef: any;
    taMenuRef: any;
    compareMenuRef: any;
    toogleRef: any;
    upperToogleRef: any;
    lowerToogleRef: any;

    isOpen = false
    isToogleOn = false
    isClickToggle = false

    constructor(props: any) {
        super(props)
        this.chartRef = React.createRef();
        this.filter = React.createRef();
        this.typeMenuRef = React.createRef();
        this.taMenuRef = React.createRef();
        this.compareMenuRef = React.createRef();
        this.toogleRef = React.createRef();
        this.upperToogleRef = React.createRef();
        this.lowerToogleRef = React.createRef();
        this.state = {

            token: this.props.token,
            intervals: [
                { key: '1D', interval: 'M' },
                { key: '1W', interval: 'D' },
                { key: '1M', interval: 'D' },
                { key: '3M', interval: 'D' },
                { key: '6M', interval: 'D' },
                { key: '1Y', interval: 'D' },
                { key: '3Y', interval: 'W' }
            ],

            fontSize: this.props.fontSize,

            //chart config
            selectedInterval: '1D',
            type: 'candlestick',
            ccy: '',
            compare: '',
            overlay: '',
            overlayConfig: '',
            tapane: '',
            tapaneConfig: '',

            //display config
            compareSetting: false,
            typeSetting: false,
            taSetting: false,
            enableUpperTA: false,
            enableLowerTA: false,
            isSMAShow: false,
            isBBShow: false,
            isRSIShow: false,
            isMACDShow: false,
            isFKDShow: false,
            isSKDShow: false,
            isSMAchecked: true,
            isRSIchecked: true,

            selectedUpperTA: 'SMA',
            selectedLowerTA: 'RSI',

            fxList: this.getFXList(),
            compareList: [],
            key: '',

            isCandlestick: true,
            isLine: false,
            isBar: false,

            displayFx: false,
            selectedccy: 0,
            selectedCompareValue: '0',
            isToogleOn: false
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
        document.addEventListener('mousedown', this.handleClickOutside);

        if (this.props.history.location.state && this.props.history.location.state.ccy !== '' && this.props.history.location.state.ccy !== 'HKD') {
            let index = this.getCCYIndex(this.props.history.location.state.ccy)
            this.setState({ ccy: this.getFXList()[index].cd, ccynm: this.getFXList()[index].nm, compareList: this.getCompareList(this.props.history.location.state.ccy, ''), selectedccy: this.getCCYIndex(this.props.history.location.state.ccy) })

        }
        else if (this.props.cc != undefined) {
            let index: number = 0
            let ccy = 'USDHKD'

            if (this.props.cc === 'BN') {
                index = this.getCCYIndex('BNDHKD')
                ccy = 'BNDHKD'
            }
            else
                index = this.getCCYIndex('USDHKD')

            this.setState({ ccy: this.getFXList()[index].cd, ccynm: this.getFXList()[index].nm, compareList: this.getCompareList(ccy, ''), selectedccy: index })
        }
        else {
            this.setState({ ccy: fxList[0].cd, ccynm: fxList[0].nm, compareList: this.getCompareList(this.state.ccy, ''), selectedccy: 0 })
        }
        this.props.history.push('/chart?lang=' + this.props.lang + '&cc=' + this.props.cc);
        this.props.widget(false)
    }

    componentWillReceiveProps(nextProps: any) {

        if (nextProps.lang !== undefined && nextProps.lang !== this.props.lang) {
            this.props.history.push('/chart?lang=' + nextProps.lang + '&cc=' + nextProps.cc);
            this.setState({ ccy: cc2ccy(nextProps.cc) }, () => {
                this.setState({ fxList: this.getFXList() }, () => {
                    this.setState({
                        ccy: this.getFXList()[this.state.selectedccy].cd,
                        ccynm: this.getFXList()[this.state.selectedccy].nm,
                        compareList: this.getCompareList(this.state.ccy, ''),
                        compare: this.state.compareList[this.state.selectedCompareValue].cd,
                        comparenm: this.state.compareList[this.state.selectedCompareValue].nm
                    })
                })
            })
        } else {
            //update seleted lang when the lang have update
            this.setState({ fxList: this.getFXList() }, () => {
                this.setState({
                    ccy: this.getFXList()[this.state.selectedccy].cd,
                    ccynm: this.getFXList()[this.state.selectedccy].nm,
                    compareList: this.getCompareList(this.state.ccy, ''),
                    compare: this.state.compareList[this.state.selectedCompareValue].cd,
                    comparenm: this.state.compareList[this.state.selectedCompareValue].nm
                })

            })
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    updateDimensions = () => {
        this.chartRef.current.resizeChart('')
    }

    handleClickOutside = (event: any) => {
        if (!this.typeMenuRef.current.contains(event.target) &&
            !this.taMenuRef.current.contains(event.target) &&
            !this.compareMenuRef.current.contains(event.target)) {

            if (this.state.selectedCompareValue === '0' && this.isOpen === true) {

                if (this.state.key.length === 0) {
                    this.toogleRef.current.toggleState()
                    this.isToogleOn = false
                    this.isClickToggle = false
                }

            } else {
            }

            this.isOpen = false
            this.setState({ typeSetting: false, taSetting: false, displayFx: false })
        }
    }

    getCCYIndex(ccy: string): number {
        for (let i = 0; i < this.state.fxList.length; i++) {
            if (fxList[i].cd === ccy)
                return i
        }

        return 0
    }

    getFXList() {
        let list = [];
        for (let i = 0; i < fxList.length; i++) {
            let m = { cd: '', nm: '' };
            m.cd = fxList[i].cd;

            let ccy1 = m.cd.substring(0, 3);
            let ccy2 = m.cd.substring(3);

            m.nm = i18next.t('Common.' + ccy1, '') + '/' + i18next.t('Common.' + ccy2);
            list.push(m);
        }
        return list;
    }

    getCompareList(currentccy: any, searchccy: any) {
        let list = new Array();

        //default value
        if (searchccy === '') {
            let m = { cd: '', nm: '' };
            list.push(m);
        }

        for (let i = 0; i < fxList.length; i++) {
            if (currentccy !== fxList[i].cd) {
                if (fxList[i].cd.indexOf(searchccy) > -1 || fxList[i].nm.indexOf(searchccy) > -1) {
                    let m = { cd: '', nm: '' };
                    m.cd = fxList[i].cd;

                    let ccy1 = m.cd.substring(0, 3);
                    let ccy2 = m.cd.substring(3);

                    m.nm = i18next.t('Common.' + ccy1, '') + '/' + i18next.t('Common.' + ccy2);
                    list.push(m);
                }
            }
        }

        return list;
    }

    onIntervalChange = (value: string) => {
        if (this.state.selectedInterval !== value) {
            this.setState({ selectedInterval: value })
        }
    }

    onCurrencyChange = (e: any) => {
        this.setState({ ccy: fxList[e.currentTarget.value].cd, ccynm: fxList[e.currentTarget.value].nm, selectedccy: e.currentTarget.value })
    }

    onCompareChange = (e: any) => {
        if (e.currentTarget !== undefined) {
            this.setState({
                overlay: '',
                overlayConfig: '',
                tapane: '',
                tapaneConfig: '',
                compare: this.state.compareList[e.currentTarget.value].cd,
                comparenm: this.state.compareList[e.currentTarget.value].nm,
                selectedCompareValue: e.currentTarget.value
            }, () => {
                if (this.state.enableUpperTA) {
                    this.upperToogleRef.current.toggleState()
                }

                if (this.state.enableLowerTA) {
                    this.lowerToogleRef.current.toggleState()
                }
            })
        }
        else {
            this.setState({ compare: '', comparenm: '' })
        }
    }

    //Menu Enable or Disable
    onCompareMenuChange = (e: any) => {
        if (e.isClickToggle != false) {
            this.isClickToggle = true
            if (e.isShow === 1) {
                this.isToogleOn = true
            } else {
                this.isToogleOn = false
            }
        }
    }

    onCompareMenuClick = () => {

        if (this.isOpen) {
            if (this.state.selectedCompareValue === '0' && this.state.key.length === 0) {
                this.isOpen = false
                this.isClickToggle = false
                this.isToogleOn = false
                this.setState({ displayFx: false, typeSetting: false, taSetting: false })
                this.toogleRef.current.toggleState()
            }
            else {
                this.isOpen = false
                this.isClickToggle = false
                this.isToogleOn = false
                this.setState({ displayFx: false, typeSetting: false, taSetting: false, selectedCompareValue: '0', key: '', compare: '', comparenm: '' })
                this.toogleRef.current.toggleState()
            }
        } else {
            if (!this.isToogleOn && this.state.selectedCompareValue === '0' && this.state.key.length === 0) {
                this.isClickToggle = false
                this.isOpen = true
                this.setState({ displayFx: true, typeSetting: false, taSetting: false })
                this.toogleRef.current.toggleState()
                this.isToogleOn = true
                this.clearFilter(null)
            }
            else if ((this.isToogleOn && this.state.selectedCompareValue !== '0') ||
                (this.isToogleOn && this.state.selectedCompareValue === '0' && this.state.key.length !== 0)) {
                this.isClickToggle = false
                this.isOpen = true
                this.isToogleOn = true
                this.setState({ displayFx: true, typeSetting: false, taSetting: false })
            }
            else if ((this.isClickToggle && !this.isToogleOn && this.state.selectedCompareValue !== '0') ||
                (this.isClickToggle && !this.isToogleOn && this.state.selectedCompareValue === '0' && this.state.key.length !== 0)) {
                this.isClickToggle = false
                this.isOpen = false
                this.isToogleOn = false
                this.setState({ displayFx: false, typeSetting: false, taSetting: false, selectedCompareValue: '0', key: '', compare: '', comparenm: '' })
                this.clearFilter(null)
            }
        }
    }

    onTypeMenuChange = () => {
        if (!this.state.typeSetting)
            this.setState({ displayFx: false, typeSetting: true, taSetting: false }, () => {
                if (this.isToogleOn && this.state.selectedCompareValue === '0' && this.state.key.length === 0) {
                    this.toogleRef.current.toggleState()
                    this.isToogleOn = false
                    this.isOpen = false
                }
            })
        else
            this.setState({ displayFx: false, typeSetting: false, taSetting: false })
    }

    onTaMenuChange = () => {
        if (!this.state.taSetting)
            this.setState({ displayFx: false, typeSetting: false, taSetting: true }, () => {
                if (this.isToogleOn && this.state.selectedCompareValue === '0' && this.state.key.length === 0) {
                    this.toogleRef.current.toggleState()
                    this.isToogleOn = false
                    this.isOpen = false
                }
            })
        else
            this.setState({ displayFx: false, typeSetting: false, taSetting: false })
    }

    //Type Change
    onTypeChange = (value: string) => {

        if (value === "candlestick")
            if (this.isToogleOn) {
                this.isToogleOn = false
                this.isOpen = false
                this.toogleRef.current.toggleState()
                this.setState({ isCandlestick: true, isLine: false, isBar: false, type: value, selectedCompareValue: '0', key: '', compare: '', comparenm: '' })
                this.clearFilter(null)
            } else {
                this.setState({ isCandlestick: true, isLine: false, isBar: false, type: value, selectedCompareValue: '0', key: '', compare: '', comparenm: '' })
            }
        else if (value === "line")
            if (this.isToogleOn) {
                this.isToogleOn = false
                this.isOpen = false
                this.toogleRef.current.toggleState()
                this.setState({ isCandlestick: false, isLine: true, isBar: false, type: value, selectedCompareValue: '0', key: '', compare: '', comparenm: '' })
                this.clearFilter(null)
            } else
                this.setState({ isCandlestick: false, isLine: true, isBar: false, type: value, selectedCompareValue: '0', key: '', compare: '', comparenm: '' })
        else
            if (this.isToogleOn) {
                this.isToogleOn = false
                this.isOpen = false
                this.toogleRef.current.toggleState()
                this.setState({ isCandlestick: false, isLine: false, isBar: true, type: value, selectedCompareValue: '0', key: '', compare: '', comparenm: '' }, () => {
                })
                this.clearFilter(null)
            } else
                this.setState({ isCandlestick: false, isLine: false, isBar: true, type: value, selectedCompareValue: '0', key: '', compare: '', comparenm: '' })

    }

    onChangeUpperTA = (ta: string) => {
        switch (ta) {
            case 'SMA':
                this.setState({ isSMAchecked: true, isBBchecked: false, isSARchecked: false, selectedUpperTA: ta, isSMAShow: true, overlay: ta, overlayConfig: { p1: 5, p2: 25, p3: 75 }, isBBShow: false });
                break;
            case 'BB':
                this.setState({ isSMAchecked: false, isBBchecked: true, isSARchecked: false, selectedUpperTA: ta, isSMAShow: false, overlay: ta, overlayConfig: { p: 25 }, isBBShow: true });
                break;
            case 'SAR':
                this.setState({ isSMAchecked: false, isBBchecked: false, isSARchecked: true, selectedUpperTA: ta, isSMAShow: false, overlay: ta, overlayConfig: {}, isBBShow: false });
                break;
        }
    }

    onChangeLowerTA = (ta: string) => {
        switch (ta) {
            case 'RSI':
                this.setState({
                    selectedLowerTA: ta,
                    isRSIchecked: true, isMACDchecked: false, isSKDchecked: false, isFKDchecked: false,
                    isRSIShow: true, isMACDShow: false, isFKDShow: false, isSKDShow: false,
                    tapane: ta, tapaneConfig: { p: 14 }
                });
                break;
            case 'MACD':
                this.setState({
                    selectedLowerTA: ta,
                    isRSIchecked: false, isMACDchecked: true, isSKDchecked: false, isFKDchecked: false,
                    isRSIShow: false, isMACDShow: true, isFKDShow: false, isSKDShow: false,
                    tapane: ta, tapaneConfig: { fast: 12, slow: 26, signal: 9 }
                });
                break;
            case 'SKD':
                this.setState({
                    selectedLowerTA: ta,
                    isRSIchecked: false, isMACDchecked: false, isSKDchecked: true, isFKDchecked: false,
                    isRSIShow: false, isMACDShow: false, isFKDShow: false, isSKDShow: true,
                    tapane: ta, tapaneConfig: { k: 14, d: 9 }
                });
                break;
            case 'FKD':
                this.setState({
                    selectedLowerTA: ta,
                    isRSIchecked: false, isMACDchecked: false, isSKDchecked: false, isFKDchecked: true,
                    isRSIShow: false, isMACDShow: false, isFKDShow: true, isSKDShow: false,
                    tapane: ta, tapaneConfig: { k: 14, d: 9 }
                });
                break;
        }
    }

    changeOverlayConfig = (config: any) => {
        this.setState({ overlayConfig: config });
    }

    changeTAPaneConfig = (config: any) => {
        this.setState({ tapaneConfig: config });
    }

    onUpperTAEnableOrDisable = (isShow: any) => {

        if (isShow) {
            this.setState(
                { enableUpperTA: true, selectedCompareValue: '0' },
                () => {
                    this.isOpen = false
                    this.setState({ displayFx: false })
                    if (this.isToogleOn) {
                        this.setState({ selectedCompareValue: '0', key: '', compare: '', comparenm: '' }, () => {
                            this.isToogleOn = false
                            this.toogleRef.current.toggleState()
                            this.onChangeUpperTA(this.state.selectedUpperTA)
                            this.clearFilter(null)
                        })
                    } else {
                        this.onChangeUpperTA(this.state.selectedUpperTA)
                    }
                }
            );
        }
        else
            this.setState({ enableUpperTA: false, overlay: '', overlayConfig: '', isSMAShow: false, isBBShow: false })
    }

    onLowerTAEnableOrDisable = (isShow: any) => {
        if (isShow) {

            this.setState({ enableLowerTA: true, selectedCompareValue: '0' }, () => {
                this.isOpen = false
                this.setState({ displayFx: false })
                if (this.isToogleOn) {
                    this.setState({ selectedCompareValue: '0', key: '', compare: '', comparenm: '' }, () => {
                        this.isToogleOn = false
                        this.toogleRef.current.toggleState()
                        this.onChangeLowerTA(this.state.selectedLowerTA)
                        this.clearFilter(null)
                    })
                } else {
                    this.onChangeLowerTA(this.state.selectedLowerTA)
                }
            })
        }
        else
            this.setState({ enableLowerTA: false, tapane: '', tapaneConfig: '', isRSIShow: false, isMACDShow: false, isSKDShow: false, isFKDShow: false })
    }

    onChartZoomInClick = () => {
        this.chartRef.current.zoomIn()
    }

    onChartZoomOutClick = () => {
        this.chartRef.current.zoomOut()
    }

    onCompareTextChange(e: React.FormEvent<HTMLInputElement>) {
        const comapareList = this.getCompareList(this.state.ccy, e.currentTarget.value.trim().toUpperCase())
        if (comapareList.length > 0)
            this.setState({ key: e.currentTarget.value.trim().toUpperCase(), compareList: comapareList, selectedCompareValue: '0', compare: comapareList[0].cd, comparenm: comapareList[0].nm }, () => {
                if (this.state.enableUpperTA)
                    this.upperToogleRef.current.toggleState()

                if (this.state.enableLowerTA)
                    this.lowerToogleRef.current.toggleState()
            })
        else
            this.setState({ key: e.currentTarget.value.trim().toUpperCase(), compareList: comapareList })
    }

    clearFilter = (e: any) => {
        this.filter.current.value = '';
        const comapareList = this.getCompareList(this.state.ccy, '')
        this.setState({ key: '', compare: '', compareList: comapareList, selectedCompareValue: '0' })
    }

    renderClose() {
        if (this.state.key.length > 0)
            return <IconButton onClick={this.clearFilter} style={{ width: '20px', height: '20px' }} img={<img width='100%' height='100%' src={closeIcon} alt=''></img>}></IconButton>;
    }

    getSelecledCCYName(){
       return this.getFXList()[this.state.selectedccy].nm
    }

    render() {
        return (
            <div>
                <Navbar lang={this.props.lang} cc={this.props.cc} />
                <div className='content' style={{ fontSize: this.props.fontSize }}>
                    <div className='title'>{`${i18next.t('Chart.Title', '')}${' - '}${this.getSelecledCCYName()}`}</div>
                    <div className='select_container'>
                        <div>{i18next.t('Chart.SubTitle', '')}</div>
                        <select onChange={e => this.onCurrencyChange(e)} value={this.state.selectedccy}>
                            {this.getFXList().map(function (item: any, i: number) {
                                return (
                                    <option key={i} value={i}>
                                        {item.nm}
                                    </option>
                                )
                            })}3.
                        </select>
                    </div>

                    <div className="Chartbox">
                        <div className="Menubar">
                            <div className="zoomandinterval">
                                <div className="zoom zoomin" onClick={this.onChartZoomInClick} />
                                <div className="zoom zoomout" onClick={this.onChartZoomOutClick} />
                                <div className="intervalbox">
                                    <IntervalBox
                                        intervals={this.state.intervals}
                                        selectedInterval={this.state.selectedInterval}
                                        inverseStyle={false}
                                        onClick={this.onIntervalChange} />
                                </div>
                            </div>

                            <div className="Option" >
                                <div className='item type' ref={this.typeMenuRef}>
                                    <div className={this.state.typeSetting ? 'item type-on' : 'item type-off'} onClick={this.onTypeMenuChange} />
                                    <div className={this.state.typeSetting ? 'submenu setting' : 'submenu setting-none'} >
                                        <div className='charttype candlestick' onClick={() => this.onTypeChange('candlestick')}>
                                            <input id='type' name='type' type='radio' value='candlestick' checked={this.state.isCandlestick || false} defaultChecked={this.state.isCandlestick} />
                                            <img src={CandleImg} alt='' />{i18next.t('Chart.Type.CandleStick', '')}
                                        </div>
                                        <div className='charttype line' onClick={() => this.onTypeChange('line')}>
                                            <input id='type' name='type' type='radio' value='line' checked={this.state.isLine || false} />
                                            <img src={LineImg} alt='' />{i18next.t('Chart.Type.Line', '')}
                                        </div>
                                        <div className='charttype bar' onClick={() => this.onTypeChange('bar')}>
                                            <input id='type' name='type' type='radio' value='bar' checked={this.state.isBar || false} />
                                            <img src={BarImg} alt='' />{i18next.t('Chart.Type.OHLC', '')}
                                        </div>
                                    </div>
                                </div>

                                <div className='item tamenu' ref={this.taMenuRef}>
                                    <div className={this.state.taSetting ? 'item ta-on' : 'item ta-off'} onClick={this.onTaMenuChange} />
                                    <div className={this.state.taSetting ? 'submenu talist' : 'submenu talist-none'} >
                                        <div className='submenu taheader'>
                                            <div>{i18next.t('Chart.TASetting.UpperTA', '')}</div>
                                            <ToggleButton onClick={this.onUpperTAEnableOrDisable} ref={this.upperToogleRef}
                                                width='2.45' height='1.25' padding="2" enable={true} compare={false} />
                                        </div>
                                        <div style={this.state.enableUpperTA ? {} : { pointerEvents: 'none', opacity: 0.6 }}>
                                            <div className='taitem' onClick={() => this.onChangeUpperTA('SMA')}>
                                                <input type='radio' id='SMA' name='upperta' value='SMA' checked={this.state.isSMAchecked || false} defaultChecked={this.state.isSMAchecked} /><label className='taname' htmlFor='SMA'>{i18next.t('Chart.TA.SMA', '')}</label>
                                            </div>
                                            <div className={this.state.isSMAShow ? 'tadetail SMAisShow' : 'tadetail SMAHide'}>
                                                <SMAConfig onChange={this.changeOverlayConfig} config={this.state.overlayConfig} />
                                            </div>
                                            <div className='taitem' onClick={() => this.onChangeUpperTA('BB')}>
                                                <input type='radio' id='BB' name='upperta' value='BB' checked={this.state.isBBchecked || false} /><label className='taname' htmlFor='BB'>{i18next.t('Chart.TA.BB', '')}</label>
                                            </div>
                                            <div className={this.state.isBBShow ? 'tadetail BBisShow' : 'tadetail BBHide'}>
                                                <BBConfig onChange={this.changeOverlayConfig} config={this.state.overlayConfig} />
                                            </div>
                                            <div className='taitem' onClick={() => this.onChangeUpperTA('SAR')}>
                                                <input type='radio' id='SAR' name='upperta' value='SAR' checked={this.state.isSARchecked || false} /><label className='taname' htmlFor='SAR'>{i18next.t('Chart.TA.SAR', '')}</label>
                                            </div>
                                        </div>

                                        <div className='submenu taheader'>
                                            <div>{i18next.t('Chart.TASetting.LowerTA', '')}</div>
                                            <ToggleButton onClick={this.onLowerTAEnableOrDisable} ref={this.lowerToogleRef}
                                                width='2.45' height='1.25' padding="2" enable={true} compare={false} />
                                        </div>
                                        <div style={this.state.enableLowerTA ? {} : { pointerEvents: 'none', opacity: 0.6 }}>
                                            <div className='taitem disabled' onClick={() => this.onChangeLowerTA('RSI')}>
                                                <input type='radio' id='RSI' name='lowerta' value='RSI' checked={this.state.isRSIchecked || false} defaultChecked={this.state.isRSIchecked} />
                                                <label className='taname' htmlFor='RSI'>{i18next.t('Chart.TA.RSI', '')}</label>
                                            </div>
                                            <div className={this.state.isRSIShow ? 'tadetail RSIShow' : 'tadetail RSIHide'}>
                                                <RSIConfig onChange={this.changeTAPaneConfig} config={this.state.tapaneConfig} />
                                            </div>

                                            <div className='taitem disabled' onClick={() => this.onChangeLowerTA('MACD')}>
                                                <input type='radio' id='MACD' name='lowerta' value='MACD' checked={this.state.isMACDchecked || false} />
                                                <label className='taname' htmlFor='MACD'>{i18next.t('Chart.TA.MACD', '')}</label>
                                            </div>
                                            <div className={this.state.isMACDShow ? 'tadetail MACDShow' : 'tadetail MACDHide'}>
                                                <MACDConfig onChange={this.changeTAPaneConfig} config={this.state.tapaneConfig} />
                                            </div>
                                            <div className='taitem disabled' onClick={() => this.onChangeLowerTA('SKD')}>
                                                <input type='radio' id='SKD' name='lowerta' value='SKD' checked={this.state.isSKDchecked || false} />
                                                <label className='taname' htmlFor='SKD'>{i18next.t('Chart.TA.SKD', '')}</label>
                                            </div>
                                            <div className={this.state.isSKDShow ? 'tadetail SKDShow' : 'tadetail SKDHide'}>
                                                <SKDConfig onChange={this.changeTAPaneConfig} config={this.state.tapaneConfig} />
                                            </div>
                                            <div className='taitem disabled' onClick={() => this.onChangeLowerTA('FKD')}>
                                                <input type='radio' id='FKD' name='lowerta' value='FKD' checked={this.state.isFKDchecked || false} />
                                                <label className='taname' htmlFor='FKD'>{i18next.t('Chart.TA.FKD', '')}</label>
                                            </div>
                                            <div className={this.state.isFKDShow ? 'tadetail FKDShow' : 'tadetail FKDHide'}>
                                                <FKDConfig onChange={this.changeTAPaneConfig} config={this.state.tapaneConfig} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="item compare" ref={this.compareMenuRef}>
                                    <div className={this.state.displayFx ? 'comparemenu-on' : 'comparemenu-off'} onClick={this.onCompareMenuClick} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <div style={{ marginRight: '5px', fontSize: '95%' }}>{i18next.t('Chart.Menu', '')}</div>
                                        <div className="comparetoggle" style={{ display: 'flex' }}>
                                            <CompareToggleButton ref={this.toogleRef} onClick={this.onCompareMenuChange}
                                                width='2.45' height='1.25' padding="2" enable={true} compare={false} />
                                        </div>
                                    </div>
                                    <div className={this.state.displayFx === true ? 'submenu comparemenu' : 'submenu comparemenu-none'}>
                                        <div className='comparefx'>
                                            <div className='compare-searchbox'>
                                                <input placeholder={i18next.t("Common.SearchCurrency", "")} ref={this.filter} onChange={e => this.onCompareTextChange(e)}></input>
                                                <div className='compare-searchbox-clear'>
                                                    {this.renderClose()}
                                                </div>
                                            </div>
                                            <div className='compare-select'>
                                                <div className='comparefx-title'>{i18next.t('Chart.MenuItem', '')}</div>
                                                <select onChange={e => this.onCompareChange(e)} value={this.state.selectedCompareValue} style={{ margin: 'auto', marginLeft: '0px', width: '180px', height: '25px' }}>
                                                    {
                                                        this.state.compareList.map((item: any, i: number) => {
                                                            return (
                                                                <option key={i} value={i}>
                                                                    {item.nm}
                                                                </option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="chart">
                            <Chart5 ref={this.chartRef}
                                token={this.props.token}
                                fontsize={this.props.fontsize}
                                enableScrollPane={true}
                                full={this.state.fullChart}
                                ccy={this.state.ccy}
                                ccynm={this.state.ccynm}
                                compare={this.state.compare}
                                comparenm={this.state.comparenm}
                                type={this.state.type}
                                overlay={this.state.overlay}
                                overlayConfig={this.state.overlayConfig}
                                tapane={this.state.tapane}
                                tapaneConfig={this.state.tapaneConfig}
                                period={this.state.selectedInterval}
                                domain={this.props.domain}>
                            </Chart5>
                        </div>
                        <div className='scrollpane' />
                    </div>
                </div>
            </div>
        )
    }
}
